module.exports = __webpack_public_path__ + "static/img/artist-rob@2x.66935da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artist/artist-rob@2x.png
// module id = IMhj
// module chunks = 12